module.exports = __webpack_public_path__ + "img/attachment-02.d4da59b2.svg";